/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Delivery_CountInputs */

const vi_report_delivery_count = /** @type {(inputs: Report_Delivery_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số đơn giao`)
};

/**

* @param {Report_Delivery_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_delivery_count = /** @type {((inputs?: Report_Delivery_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Delivery_CountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_delivery_count(inputs)
});